export default __webpack_public_path__ + "static/media/1.48bd8ae8.png";